<template>
  <div class="tab-cover-wrap ">
    <h1 class="text-[14px] font-semibold text-[#14171F]">Business Status</h1>

   <div class="business-status pt-4">
      <div class="">
        <div class="flex  justify-between items-center mb-8 pl-2">
          <div class="box-cover  flex items-center">
            <div :class="['color-box', { 'active': selected === 'Incorporated' }]" @click="selectOption('Incorporated')"></div>
            <p class="ml-2 text-[64px] font-bold text-[#383F51]">Incorporated</p>
          </div>
          <div class="box-cover  flex items-center">
            <div :class="['color-box', { 'active': selected === 'Registered Name' }]" @click="selectOption('Registered Name')"></div>
            <p class="ml-2 text-[14px] font-bold text-rose-500">Registered Name</p>
          </div>
        </div>

        <div v-if="selected === 'Incorporated'">
          <Incorporated :selected="selected" @openRegisteredAddress="openRegisteredAddress" />
        </div>
        
        <div v-if="selected === 'Registered Name'" >
          <RegisteredName />
        </div>
      </div>

    </div>
  </div>
</template>

 <script>
 import Incorporated from './modules/Incorporated.vue';
 import RegisteredName from './modules/RegisteredName .vue';

export default {
   components: {
        Incorporated,
        RegisteredName,
       
    },
     props: ['selectedReuploadTab'],

     watch: {
  selectedReuploadTab: {
    handler(newVal) {
      if (this.selectedReuploadTab === 'Incorporated') {
        this.selected = newVal 
      }
    },
    deep: true,
    immediate: true
  }
},

  data() {
    return {
      selected: null, 
    };
  },
    methods: {
      openRegisteredAddress(kycData) {
        this.$emit('openRegisteredAddress', kycData); 

      },
      selectOption(option) {
      this.selected = option;
    },
      selectTab(index) {
            this.selectedIndex = index;
        },
    },

  };
  </script>
 
 <style scoped>
 .business-status{
  /* border: 1px solid red; */
 }
 .business-status>:nth-child(1)>:nth-child(1){
  width: 35%;
 }
 .color-box.active {
  background-color: #FFA600;
}

.color-box {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  border: 1px solid #C5C4D4;
  cursor: pointer;
}

.box-cover>p {
  color: #383F51;
  font-size: 14px;
  font-weight: 400;
}
</style>
